import React from 'react'
import styled, { css } from 'styled-components'
import { useTheme } from '../../../../../context/ThemeContext'

const Svg = styled.svg`
  transition: transform 0.1s ease;

  ${({ $isHovered }) => $isHovered ? css`
    transform: scale(1.03);
  ` : css`
    transform: scale(1);
  `}
`

export default function ListCross({ size = 24, isActive = false, isHovered = false }) {
  const { theme } = useTheme()
  return (
    <Svg xmlns='http://www.w3.org/2000/svg' width={`${size}px`} height={`${size}px`} viewBox='0 0 24 24' fill='none' $isHovered={isHovered}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.25 6C2.25 5.58579 2.58579 5.25 3 5.25H20C20.4142 5.25 20.75 5.58579 20.75 6C20.75 6.41421 20.4142 6.75 20 6.75H3C2.58579 6.75 2.25 6.41421 2.25 6ZM2.25 11C2.25 10.5858 2.58579 10.25 3 10.25H11C11.4142 10.25 11.75 10.5858 11.75 11C11.75 11.4142 11.4142 11.75 11 11.75H3C2.58579 11.75 2.25 11.4142 2.25 11ZM2.25 16C2.25 15.5858 2.58579 15.25 3 15.25H11C11.4142 15.25 11.75 15.5858 11.75 16C11.75 16.4142 11.4142 16.75 11 16.75H3C2.58579 16.75 2.25 16.4142 2.25 16Z'
        fill={theme === 'light' ?
          ((isActive) ? '#fff' : (isHovered ? 'var(--main-color)' : 'var(--grey-color)'))
          :
          ((isActive || isHovered) ? 'var(--list-text-color)' : 'var(--list-text-color)')}
      />
      <path
        d='M14.4697 10.4697C14.7626 10.1768 15.2374 10.1768 15.5303 10.4697L17.5 12.4393L19.4697 10.4697C19.7626 10.1768 20.2374 10.1768 20.5303 10.4697C20.8232 10.7626 20.8232 11.2374 20.5303 11.5303L18.5607 13.5L20.5303 15.4697C20.8232 15.7626 20.8232 16.2374 20.5303 16.5303C20.2374 16.8232 19.7626 16.8232 19.4697 16.5303L17.5 14.5607L15.5303 16.5303C15.2374 16.8232 14.7626 16.8232 14.4697 16.5303C14.1768 16.2374 14.1768 15.7626 14.4697 15.4697L16.4393 13.5L14.4697 11.5303C14.1768 11.2374 14.1768 10.7626 14.4697 10.4697Z'
        fill='var(--red-color)' />
    </Svg>
  )
}